import React, { useRef, useState } from "react";
import "./LineInfoMain.css";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { OverlayPanel } from "primereact/overlaypanel";
import { SwapperSvg } from "./assets/Svg";
import { SwapEsn } from "./components/SwapEsn/SwapEsn";
import ChangeCustomerPlan from "./components/Change_Customer_Plans/Change_Customer_Plans";
import { PlanEdit } from "../../../../../../../utility";
import { ESIMProfileDialog } from "../TopBarCustomerProfile/components/ESIMProfileDialog/ESIMProfileDialog";
import CommonLoaderBlue from "../../../../../../components/Loader/LoaderBlue";
export const CustomerLineInfoMain = ({
  isServiceInfoApiCalled,
  cpData,
  planData,
}) => {
  const [overlayContent, setOverlayContent] = useState("");
  const statusOverlayRef = useRef(null);
  const toastRef = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [changeCustomerPlan, setChangeCustomerPlan] = useState(false);

  const socOverlayRef = useRef(null);
  const [showSwapEsn, setShowSwapEsn] = useState(false);
  const [qrDialogVisible, setQrDialogVisible] = useState(false);
  return (
    <div className="line-info-wrapper">
      {showSwapEsn && (
        <SwapEsn cpData={cpData} setShowSwapEsn={setShowSwapEsn} />
      )}
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>MDN</p>
        <p>{cpData?.phoneNumber || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>SIM/ESN</p>
        <div
          style={{ gap: "0.8rem", marginRigt: "-0.25rem" }}
          className="flex flex-wrap flex-row justify-content-end align-items-center"
        >
          <p>{cpData?.esn ?? cpData?.esnId?.esn ?? "NIL"}</p>
          {(cpData?.esn ?? cpData?.esnId?.esn) && (
            <div
              onClick={() => {
                setShowSwapEsn((prev) => !prev);
              }}
              style={{ marginLeft: "" }}
              className="cursor-pointer"
            >
              <SwapperSvg />
            </div>
          )}
        </div>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Activation IMEI</p>
        <p>{cpData?.IMEI2 ?? cpData?.esnId?.IMEI2 ?? "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Inventory IMEI</p>
        <p>{cpData?.IMEI && cpData?.IMEI?.length > 0 ? cpData?.IMEI : "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Inventory Type</p>
        <p>{cpData?.plan?.inventoryType || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Make</p>
        <p>{cpData?.plan?.make || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Model</p>
        <p>{cpData?.plan?.deviceModel || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>E-SIM</p>
        <div className="flex align-items-center" style={{ gap: "0.8rem" }}>
          <p>{cpData?.ESim ? "YES" : "NO"}</p>
          {cpData?.ESim && (
            <span
              onClick={() => setQrDialogVisible(true)}
              className="cursor-pointer flex align-items-center"
              title="View eSIM QR Code"
              style={{
                color: "#475ced",
                fontSize: "1.2rem",
                fontWeight: 600,
                gap: "0.4rem",
              }}
            >
              <i className="pi pi-qrcode" style={{ fontSize: "1.6rem" }} />
              <span>QR</span>
            </span>
          )}
        </div>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Ported MDN</p>
        <p>{cpData?.portedMDN ? "YES" : "NO"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Acc. Type</p>
        <p>{cpData?.accountType || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>
          Plan Name
          {/* <i
                        onClick={() => {
                            setChangeCustomerPlan((prev) => !prev);
                        }}
                        className="pi plan-icon pi-pencil"
                    /> */}
        </p>
        {/* <p>{cpData?.currentPlan?.planName ?? "NIL"}</p> */}
        <p
          className="flex"
          style={{ gap: "0.8rem", cursor: "pointer", alignItems: "center" }}
        >
          {cpData?.currentPlan?.planName ?? "NIL"}
          {cpData?.currentPlan?.planName && (
            <span
              onClick={() => {
                setChangeCustomerPlan((prev) => !prev);
              }}
            >
              <PlanEdit />
            </span>
          )}
        </p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Plan Details</p>
        <p
          className="cursor-pointer"
          onMouseEnter={(e) => {
            if (cpData?.plan?.description?.length > 23) {
              setOverlayContent(cpData?.plan?.description);
              statusOverlayRef.current.show(e);
            }
          }}
          onMouseLeave={() => statusOverlayRef.current.hide()}
        >
          {cpData?.plan?.description?.length > 60
            ? `${cpData.plan.description.slice(0, 60)}...`
            : cpData?.plan?.description && cpData?.plan?.description !== ""
              ? cpData?.plan.description
              : "NIL"}
        </p>
        <OverlayPanel ref={statusOverlayRef}>
          <div style={{ maxWidth: "42rem", padding: "0.5rem 1rem" }}>
            <p
              style={{
                fontWeight: 400,
                fontSize: "1.4rem",
                overflow: "hidden",
                border: "none",
                margin: "0rem",
                lineHeight: "1.8rem",
                color: "#72728f",
              }}
            >
              {" "}
              {overlayContent}
            </p>
          </div>
        </OverlayPanel>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Plan Price</p>
        <p>{cpData?.plan?.price || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Plan Activation Date</p>
        <p>
          {cpData?.activatedAt
            ? moment(cpData.activatedAt).format("YYYY-MM-DD HH:mm:ss")
            : "NIL"}
        </p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Carrier Live Status</p>
        <p>{cpData?.serviceStatus || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>OCS Live Status</p>
        <p>{cpData?.ocsStatus || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Talk Balance</p>
        <p>
          {isServiceInfoApiCalled ? (
            (planData?.talkBalance ?? "NIL")
          ) : (
            <CommonLoaderBlue sizehere={13} color="royalblue" />
          )}
        </p>
      </div>

      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>SMS Balance</p>
        <p>
          {isServiceInfoApiCalled ? (
            (planData?.textBalance ?? "NIL")
          ) : (
            <CommonLoaderBlue sizehere={13} color="royalblue" />
          )}
        </p>
      </div>

      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Data Balance</p>
        <p>
          {isServiceInfoApiCalled ? (
            (planData?.dataBalance ?? "NIL")
          ) : (
            <CommonLoaderBlue sizehere={13} color="royalblue" />
          )}
        </p>
      </div>

      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Plan ID</p>
        <p>{cpData?.plan?.planId || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>Plan Expiration Date</p>
        <p>
          {cpData?.planExpirationDate
            ? moment(cpData?.planExpirationDate).format("YYYY-MM-DD HH:mm:ss")
            : "NIL"}
        </p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>SOC</p>
        <p
          onMouseEnter={(e) => {
            if (cpData?.socs?.map(String).join(",").length > 60) {
              setOverlayContent(cpData?.socs?.map(String).join(", "));
              socOverlayRef.current.show(e);
            }
          }}
          onMouseLeave={() => socOverlayRef.current.hide()}
        >
          {cpData?.socs &&
          cpData?.socs.length > 0 &&
          cpData?.socs?.map(String).join(",").length > 60
            ? cpData?.socs?.map(String).join(",").substring(0, 57) + "..."
            : cpData?.socs && cpData?.socs.length > 0
              ? cpData?.socs?.map(String).join(",")
              : "NIL"}
        </p>
        <OverlayPanel ref={socOverlayRef}>
          <div style={{ maxWidth: "48rem", padding: "0.5rem 1rem" }}>
            <p
              style={{
                fontWeight: 400,
                fontSize: "1.4rem",
                overflow: "hidden",
                border: "none",
                margin: "0rem",
                lineHeight: "1.8rem",
                color: "#72728f",
              }}
            >
              {" "}
              {overlayContent}
            </p>
          </div>
        </OverlayPanel>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>
          {cpData?.carrier?.name === "AT&T"
            ? "BAN"
            : cpData?.carrier?.name === "TMB"
              ? "PUK 1"
              : "NIL"}
        </p>
        <p>{cpData?.BAN || cpData?.PUK1 || "NIL"}</p>
      </div>
      <div className="detail-item flex flex-wrap flex-row justify-content-between align-items-center">
        <p>
          {cpData?.carrier?.name === "AT&T"
            ? "FAN"
            : cpData?.carrier?.name === "TMB"
              ? "PUK 2"
              : "NIL"}
        </p>
        <p>{cpData?.FAN || cpData?.PUK2 || "NIL"}</p>
      </div>
      <div className="dialogmain">
        <Dialog
          draggable={false}
          // header="Change Customer Plan"
          closable={false}
          visible={changeCustomerPlan}
          onHide={() => {
            setChangeCustomerPlan(false);
            setRefresh((prev) => !prev);
          }}
          headerClassName="dialogheaderplanedit"
        >
          <ChangeCustomerPlan
            setRefresh={setRefresh}
            setChangeCustomerPlan={setChangeCustomerPlan}
            customerId={cpData?._id}
          />
        </Dialog>
        {qrDialogVisible && (
          <ESIMProfileDialog
            toast={toastRef}
            cpData={cpData}
            setVisible={setQrDialogVisible}
          />
        )}
        <Toast ref={toastRef} />
      </div>
    </div>
  );
};
